import { render } from "./MachineLearning.vue?vue&type=template&id=4b16d2e0"
import script from "./MachineLearning.vue?vue&type=script&lang=js"
export * from "./MachineLearning.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__